import { Navigate, Route, Routes } from 'react-router-dom';
import { CampaignPage, EditCampaignPage } from '@pages/Admin';
import { ConversationDownload } from '@pages/ConversationDownload';
import { RecordingRedirect } from '@pages/RecordingRedirect';
import { AssistantsPage } from '@pages/Admin/Assistants';
import { AuthenticatedPath } from '@shared/constants/routes.constants';
import { FullLayout } from '@shared/layouts';
import { UserLoader } from './UserLoader';

export const AuthorizedRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FullLayout />}>
        <Route element={<UserLoader />}>
          <Route path="/" element={<CampaignPage />} />
          <Route
            path={AuthenticatedPath.HOME}
            element={<Navigate to={AuthenticatedPath.CAMPAIGN} replace />}
          />
          <Route path={AuthenticatedPath.CAMPAIGN} element={<CampaignPage />} />
          <Route path={AuthenticatedPath.ASSISTANTS} element={<AssistantsPage />} />
          <Route path={AuthenticatedPath.EDIT_CAMPAIGN_V2} element={<EditCampaignPage />} />
          <Route
            path={AuthenticatedPath.CONVERSATION_DOWNLOAD}
            element={<ConversationDownload />}
          />
          <Route path={AuthenticatedPath.RECORDING} element={<RecordingRedirect />} />
          <Route path="*" element={<Navigate to={AuthenticatedPath.CAMPAIGN} replace />} />
        </Route>
      </Route>
    </Routes>
  );
};
